













































import Vue from "vue";
import mixins from "vue-typed-mixins";
import PageExpander from "./PageExpander.vue";
import { IPage } from "../store/state";
import ItemExpander, {
  ItemExpanderData,
  ItemExpanderMethods,
  ItemExpanderProps,
  ItemExpanderComputed
} from "../mixins/ItemExpander";

interface MenuItemProps {
  page: IPage;
  focus: boolean;
}

interface MenuItemComputed {
  tabindex: number;
}

export default Vue.extend<{}, {}, MenuItemComputed, MenuItemProps>({
  name: "MenuItem",
  props: {
    page: {
      type: Object,
      required: true
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tabindex() {
      return this.page.open ? 0 : -1;
    }
  },
  components: {
    PageExpander
  }
});
